<template lang="html">
  <!-- @contextmenu.capture.prevent -->
  <button
    ref="dropdown"
    v-bind="$attrs"
    class="ms-con-dropdown parent-dropdown"
    type="button"
    v-on="listeners">
    <slot/>
  </button>
</template>

<script>
//import eventBusGlobal from "@/bus/eventBusGlobal.js";

export default {
  name: "MsDropdown",
  inheritAttrs: false,
  props: {
    msTriggerClick: {
      default: false,
      type: Boolean
    },
    msTriggerContextmenu: {
      default: false,
      type: Boolean
    },
    color: {
      default: "primary",
      type: String
    },
    msCustomContent: {
      default: false,
      type: Boolean
    },
    msDropRight: {
      default: false,
      type: Boolean
    },
    isMsDropdownVisible: {
      default: false,
      type: [String, Boolean]
    },
  },
  data: () => ({
    msDropdownVisible: false,
    rightx: false
  }),
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        contextmenu: evt =>
          this.msTriggerContextmenu ? this.clickToogleMenu(evt, true) : {},
        click: evt => {
          if (!this.msTriggerContextmenu) {
            this.clickToogleMenu(evt);
          }

          if (this.$el === evt.target) {
            this.$emit("click");
          }
        },
        mouseout: evt => this.toggleMenu("out", evt),
        mouseover: evt => this.toggleMenu("over", evt)
      };
    }
  },
  watch: {
    msDropdownVisible() {
      this.changePositionMenu();
      if (this.msDropdownVisible) {
        this.$emit("focus");
        document.addEventListener("click", this.clickx);
      } else {
        this.$emit("blur");
      }
    },
     isMsDropdownVisible() {
      let [dropdownMenu] = this.$children.filter(item =>
        item.hasOwnProperty("dropdownVisible")
      );
      dropdownMenu && (dropdownMenu.dropdownVisible = false);
      this.msDropdownVisible = false;
    }
  },
  created() {
    // xử lý lỗi ẩn dropdown khi click button
    this.$bus.$on("clickBtn", (e) => {
      this.clickx(e);
    });
  },
  mounted() {
    this.changeColor();
    document.addEventListener("click", this.clickx);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickx);
  },
  methods: {
    clickx(evt) {
      let [dropdownMenu] = this.$children.filter(item =>
        item.hasOwnProperty("dropdownVisible")
      );
      dropdownMenu.msCustomContent = this.msCustomContent;
      dropdownMenu.msTriggerClick = this.msTriggerClick;
      dropdownMenu.msDropRight = this.msDropRight;
      if (
        (this.msTriggerClick || this.msCustomContent) &&
        this.msDropdownVisible
      ) {
        if (
          evt.target !== this.$refs.dropdown &&
          evt.target.parentNode !== this.$refs.dropdown &&
          evt.target.parentNode.parentNode !== this.$refs.dropdown
        ) {
          if (!evt.target.closest(".ms-dropdown--menu")) {
            dropdownMenu.dropdownVisible = this.msDropdownVisible = false;
            document.removeEventListener("click", this.clickx);
          }
        }
      }
    },
    changeColor() {
      let child = this.$children;
      child.forEach(item => {
        if (item.$vnode.tag.indexOf("dropdown") != -1) {
          item.color = this.color;
        }
      });
    },
    changePositionMenu() {
      let [dropdownMenu] = this.$children.filter(item =>
        item.hasOwnProperty("dropdownVisible")
      );
      let scrollTopx = window.pageYOffset || document.documentElement.scrollTop;
      if (
        this.$refs.dropdown.getBoundingClientRect().top + 300 >=
        window.innerHeight
      ) {
        this.$nextTick(() => {
          dropdownMenu.topx =
            this.$refs.dropdown.getBoundingClientRect().top -
            dropdownMenu.$el.clientHeight -
            7 +
            scrollTopx;
          dropdownMenu.notHeight = true;
        });
      } else {
        dropdownMenu.notHeight = false;
        dropdownMenu.topx =
          this.$refs.dropdown.getBoundingClientRect().top +
          this.$refs.dropdown.clientHeight +
          scrollTopx -
          5;
      }

      this.$nextTick(() => {
        var w =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;

        if (
          this.$refs.dropdown.getBoundingClientRect().left +
            dropdownMenu.$el.offsetWidth >=
          w - 25
        ) {
          // this.rightx = true
        }

        if (
          this.$refs.dropdown.getBoundingClientRect().right <
          dropdownMenu.$el.clientWidth + 25
        ) {
          dropdownMenu.leftx =
            dropdownMenu.$el.clientWidth +
            this.$refs.dropdown.getBoundingClientRect().left;
          this.rightx = true;
          return;
        }
        dropdownMenu.leftx =
          this.$refs.dropdown.getBoundingClientRect().left +
          (this.msDropRight
            ? dropdownMenu.$el.clientWidth
            : this.$refs.dropdown.clientWidth);
      });
    },
    clickToogleMenu(evt) {
      if (evt.type == "contextmenu") {
        evt.preventDefault();
      }
      let [dropdownMenu] = this.$children.filter(item =>
        item.hasOwnProperty("dropdownVisible")
      );
      if (this.msTriggerClick || this.msTriggerContextmenu) {
        if (
          this.msDropdownVisible &&
          !evt.target.closest(".ms-dropdown--menu")
        ) {
          dropdownMenu.dropdownVisible = this.msDropdownVisible = false;
        } else {
          dropdownMenu.dropdownVisible = this.msDropdownVisible = true;
          window.addEventListener("click", () => {
            if (
              !evt.target.closest(".ms-con-dropdown") &&
              !evt.target.closest(".ms-dropdown--menu")
            ) {
              dropdownMenu.dropdownVisible = this.msDropdownVisible = false;
            }
          });
        }
      }

      this.$emit("click");
    },
    toggleMenu(typex, evt) {
      let [dropdownMenu] = this.$children.filter(item =>
        item.hasOwnProperty("dropdownVisible")
      );
      if (!this.msTriggerClick && !this.msTriggerContextmenu) {
        if (typex == "over") {
          dropdownMenu.dropdownVisible = this.msDropdownVisible = true;
        } else {
          if (!evt.relatedTarget.classList.contains("ms-dropdown-menu")) {
            dropdownMenu.dropdownVisible = this.msDropdownVisible = false;
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/controls/msDropDown.scss";
.ms-con-dropdown.parent-dropdown {
  background: transparent;
}
.router-item {
  &.active {
    a {
      color: white;
      & div:last-child {
        background-color: white !important;
      }
    }
  }
  a {
    &:hover {
      color: white;
    }
  }
}
</style>
